import React from "react";
import { CSVLink } from "react-csv";
import "./ExportExcelButton.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCsv, faGear, fas } from "@fortawesome/free-solid-svg-icons";

const ExportExcelButton = (props) => {
  const processData = (data) => {
    return data.map((item) => {
      const processedItem = {};

      for (const key in item) {
        if (typeof item[key] === "string" || typeof item[key] === "number") {
          processedItem[key] = item[key];
        } else if (item[key]?.props?.children) {
          processedItem[key] = item[key].props.children;
        }
      }

      return processedItem;
    });
  };

  const processDataResult = processData(props.data);

  return (
    <div className="excel-button">
      <CSVLink
        style={{ textDecoration: "none" }}
        filename={props.filename}
        data={processDataResult}
        onClick={props.onClick}
        separator={";"}
        target="_blank"
      >
        <span>
          {"Exportar"}
          <FontAwesomeIcon icon={faFileCsv} />
        </span>
      </CSVLink>
    </div>
  );
};

export default ExportExcelButton;
